import { MarketCategory } from '@vertex-protocol/react-client';
import { ROUTES } from 'client/modules/app/consts/routes';
import { ReactNode } from 'react';

interface NavMarketCategory {
  title: ReactNode;
  description: string;
  // Destination link when clicking on the mobile nav item
  href: string;
  marketCategory: MarketCategory;
}

const COMMODITIES: NavMarketCategory = {
  title: 'Commodities',
  description: 'Gold, silver, and energy markets',
  href: `${ROUTES.perpTrading}?market=XAUTUSDT0`,
  marketCategory: 'commodity',
};

const EQUITIES: NavMarketCategory = {
  title: 'Equities',
  description: 'Single-name US equity markets',
  href: `${ROUTES.perpTrading}?market=AAPL-PERP`,
  marketCategory: 'equities',
};

const FX: NavMarketCategory = {
  title: 'FX',
  description: 'Major currency pairs',
  href: `${ROUTES.perpTrading}?market=EURUSD-PERP`,
  marketCategory: 'forex',
};

const INDICES: NavMarketCategory = {
  title: 'Indices',
  description: 'Broad equity index exposure',
  href: `${ROUTES.perpTrading}?market=QQQ-PERP`,
  marketCategory: 'index',
};

const SPOT: NavMarketCategory = {
  title: 'Spot',
  description: 'Tokenized equity spot markets',
  href: `${ROUTES.spotTrading}?market=wSPYx-USDT0`,
  marketCategory: 'spot',
};

export function useNavTradeMarketCategories() {
  return [COMMODITIES, SPOT, EQUITIES, FX, INDICES];
}
